const STORAGE_KEY = "wolf_tracking_v1";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "li_fat_id",
  "gclid",
] as const;

type UtmKey = (typeof UTM_KEYS)[number];

export type TrackingParams = Partial<Record<UtmKey, string>> & {
  referrer?: string;
  landing_page?: string;
  first_seen_at?: string;
};

export function captureTrackingParams(): void {
  if (typeof window === "undefined") return;

  try {
    const params = new URLSearchParams(window.location.search);
    const existing = getTrackingParams();
    const captured: TrackingParams = { ...existing };
    let updated = false;

    for (const key of UTM_KEYS) {
      const value = params.get(key);
      if (value && !captured[key]) {
        captured[key] = value;
        updated = true;
      }
    }

    if (!captured.landing_page) {
      captured.landing_page = window.location.pathname;
      updated = true;
    }

    if (
      !captured.referrer &&
      document.referrer &&
      !document.referrer.includes(window.location.hostname)
    ) {
      captured.referrer = document.referrer;
      updated = true;
    }

    if (!captured.first_seen_at) {
      captured.first_seen_at = new Date().toISOString();
      updated = true;
    }

    if (updated) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(captured));
    }
  } catch {
    // sessionStorage may be blocked (private mode, SSR) — fail silently.
  }
}

export function getTrackingParams(): TrackingParams {
  if (typeof window === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as TrackingParams) : {};
  } catch {
    return {};
  }
}

export function trackLinkedInConversion(conversionId: number): void {
  if (typeof window === "undefined") return;
  try {
    window.lintrk?.("track", { conversion_id: conversionId });
  } catch {
    // Insight Tag may be blocked — fail silently.
  }
}

export function trackGAEvent(
  name: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === "undefined") return;
  try {
    window.gtag?.("event", name, params);
  } catch {
    // gtag may be blocked — fail silently.
  }
}
